import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeRedesignComponent } from './components/pages/home-redesign/home-redesign.component';

import { SolutionsRedesignComponent } from './components/pages/solutions-redesign/solutions-redesign.component';
import { AboutRedesignComponent } from './components/pages/about-redesign/about-redesign.component';
import { PlatformRedesignComponent } from './components/pages/platform-redesign/platform-redesign.component';
import { NewsRedesignComponent } from './components/pages/news-redesign/news-redesign.component';
import { NewsSingleRedesignComponent } from './components/pages/news-single-redesign/news-single-redesign.component';
import { ContactRedesignComponent } from './components/pages/contact-redesign/contact-redesign.component';
import { PrivacyComponent } from './components/pages/privacy/privacy.component';
import { TermConditionsComponent } from './components/pages/terms-conditions/terms-conditions.component';
import { Fens2026Component } from './components/pages/news-single-redesign/fens2026.component';

const routes: Routes = [
    { path: '', component: HomeRedesignComponent },
    {
    path: 'solutions-redesign',
    component: SolutionsRedesignComponent
},
{
    path: 'about-redesign',
    component: AboutRedesignComponent
},
{
    path: 'platform-redesign',
    component: PlatformRedesignComponent
},
{
    path: 'news-redesign',
    component: NewsRedesignComponent
},
{
    path: 'news-redesign/fens-2026',
    component: Fens2026Component
},
{
    path: 'contact-redesign',
    component: ContactRedesignComponent
},
    // Here add new pages component

    { path: 'term-conditions', component: TermConditionsComponent},
    { path: 'privacy', component: PrivacyComponent},
    { path: '**', redirectTo: '' } // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }